var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgChecked24 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.667 7.827a.75.75 0 0 1 .068 1.059l-6.346 7.219a.75.75 0 0 1-1.096.032l-3.967-4.01a.75.75 0 0 1 1.067-1.055l3.4 3.438 5.816-6.615a.75.75 0 0 1 1.058-.068",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecked24);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };